export interface MenuItem {
  title: string;
  description: string;
}

export enum SimulatorScreenEnum {
  'WHATSAPP' = 'whatsapp',
  'ZONOMONEY' = 'zono_money',
}
